module.exports = __webpack_public_path__ + "media/styles/images/png/pen-teal-b8d84b8801b5b66b4e0386ba55965eb4.png";